export const BROTHER_PLUS_DISPLAY_CONTENT = {
    OVERVIEW: 'Overview', 
    CONFIRMATION: 'Confirmation'
};